isAnnualPlan